import { ChevronRight, ChevronLeft } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { palette } from "../../theme/palette";
import StyledChip from "./StyledChip";

const useStyles = makeStyles({
  iconChip: {
    width: "17px",
  },
  icon: {
    position: "absolute",
    left: "-33%",
    top: "-8%",
    width: "20px",
    height: "20px",
    color: palette.black,
  },
});

export const Navigation = ({ onLeft, onRight, disabled }) => {
  const styles = useStyles();

  return (
    <div>
      <StyledChip
        className={styles.iconChip}
        clickable
        disabled={disabled}
        onClick={onLeft}
        icon={<ChevronLeft className={styles.icon} />}
      />

      <StyledChip
        className={styles.iconChip}
        clickable
        disabled={disabled}
        onClick={onRight}
        icon={<ChevronRight className={styles.icon} />}
      />
    </div>
  );
};
